import config from "next/config";

const { publicRuntimeConfig } = config();

export function redirectToDashboard() {
  const dashboardUrl = new URL(publicRuntimeConfig.HOPIN_DASHBOARD_ROOT);
  window.location.assign(dashboardUrl);
}
